<div class="flex justify-between pl-4">
  <h1>Submissions</h1>
  <!--<lib-button [cssType]="'btn-primary'"  [text]="'Export'" [icon]="'rightarrow'" (mainClick)="export()"></lib-button>-->
</div>
<lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>